import "./styles/default.less"

import * as React from "react"
import * as ReactDOM from "react-dom"
import * as mockxhr from "mockxhr"
import * as qs from "query-string"

import * as util from "./util"
import AdDetailRight from "./components/AdDetailRight"
import Detail from "./components/JobDetail2"
import Footer from "./components/Footer2"
import Header from "./components/Header4"
import Partner from "./components/Partners2"
import ShareIcons from "./components/ShareIcons2"
import { Box, Item } from "./components"
import { actions } from "./flux"

interface State {
    id: string,
    item: any
    employer: any
    similar: any[]
    sibling: any[]
    siblingTotal: number
    hot: any[]
    employers: any[]
}

class View extends React.Component<{}, State> {
    constructor(props) {
        super(props)
        this.state = {
            id: util.getViewID(),
            item: null,
            employer: null,
            similar: [],
            sibling: [],
            siblingTotal: 0,
            hot: [],
            employers: [],
        }
    }

    componentDidMount() {
        window.addEventListener("resize", () => this.setState({}))
        actions.api.job.get({ id: this.state.id }, item => {
            this.setState({ item })
            actions.api.employer.get({ id: item.employerId }, employer => {
                this.setState({ employer })
            })
            actions.api.job.search({
                from: 0, size: 4, type: "LATEST",
                query: "", sort: [],
                filters: {
                    employerType: item.employerType,
                    name: item.employerType === "COLLEGE" ? item.name : undefined,
                    subjects: item.employerType === "COLLEGE" ? item.subjects[0] : undefined,
                    industries: item.employerType === "COLLEGE" ? undefined : item.industries[0],
                }
            }, res => {
                this.setState({ similar: res.hits.filter(r => r.id !== item.id) })
            })
            actions.api.job.search({
                from: 0, size: 3, type: "LATEST", sort: [],
                filters: { employerName: item.employerName },
                query: item.employerName,
            }, res => {
                this.setState({
                    sibling: res.hits.filter(r => r.id !== item.id),
                    siblingTotal: res.total - 1,
                })
            })
        })
        mockxhr.POST("/api/employers/search?type=SEARCH&size=6&from=0", {
            query: "", filters: {},
            sort: [{ weight: "DESC" }, { certApproveTime: "DESC" }],
        }, res => this.setState({ employers: res.hits }))
        actions.api.job.search({
            type: "DEFAULT", from: 0, size: 6,
            query: "", filters: {},
            sort: [{ "weight2": "DESC" }, { onlineTime: "DESC" }],
        }, res => this.setState({ hot: res.hits }))
    }

    job(i) {
        let item = this.state.hot[i]
        if (!item) return <Item flex />
        return (
            <Item flex key={item.id} className="hover-shadow-8"
                style={{ background: "white", marginTop: 24, overflow: "hidden" }}>
                <a href={"/jobs/" + item.id} style={{ display: "block", padding: 14 }} target="_blank">
                    <Box center>
                        {util.imageContain(`/api/employers/${item.employerId}/logo`, 48)}
                        {util.minWidth(14)}
                        <Item flex style={{ overflow: "hidden", lineHeight: 1.6 }}>
                            <div className="ellipsis" style={{ fontSize: 16, color: "#333" }}>
                                {item.name}
                            </div>
                            <div className="text-primary ellipsis" style={{ fontSize: 14 }}>
                                {util.salaryText(item)} &middot; {item.city}
                            </div>
                        </Item>
                    </Box>
                    <div className="text-gray" style={{ fontSize: 14, lineHeight: "24px", marginTop: 10 }}>
                        {util.fullEmployerName(item.employerName, item.department)}
                    </div>
                </a>
            </Item>
        )
    }

    render() {
        if (!this.state.item || !this.state.employer) return null
        let { item, employer } = this.state

        return (
            <Box vertical relative style={{ minHeight: "100%" }} className="min-view">
                <Header tab="JOB" search="jobs" style={{maxWidth: '1180px', minWidth: '1180px'}}/>

                <div className="min-view-center bg-color-3">
                    <div>
                        <div style={{ margin: "20px 0", fontSize: 12, color: "#333" }}>
                            您的位置：
                            <a
                                className="text-hover-primary"
                                style={{
                                        display: 'inline-block',
                                        border: '1px solid #290382',
                                        color: '#290382',
                                        padding: '1px 7px',
                                        borderRadius: '3px',
                                }}
                                href="/">
                                领研网
                            </a>
                            {" > "}
                            <a
                                className="text-hover-primary"
                                style={{
                                        display: 'inline-block',
                                        border: '1px solid #290382',
                                        color: '#290382',
                                        padding: '1px 7px',
                                        borderRadius: '3px',
                                }}
                                href="/search">
                                招聘
                            </a>
                            {" > "}
                            <a
                                className="text-hover-primary"
                                style={{
                                        display: 'inline-block',
                                        border: '1px solid #290382',
                                        color: '#290382',
                                        padding: '1px 7px',
                                        borderRadius: '3px',
                                }}
                                href={`/searchall?tab=jobs&query=${item.employerName}&filters.employerId=${item.employerId}`}>
                                {item.employerName}
                            </a>
                        </div>

                        <Box start>
                            <Box flex relative style={{ overflow: "hidden" }}>
                                {innerWidth < 1340 ?
                                    <div style={{ minWidth: 36 }}>
                                        <ShareIcons pic={item.wxShareImage} id={item.id} starType={"STAR_JOB"} fixed
                                            title={item.wxShareTitle || `${util.fullEmployerName(item.employerName, item.department)}招聘${item.name}`}
                                            description={item.wxShareDescription || `年薪：${util.salaryText(item)}；${util.researchFields(item)} - 分享自领研网`} />
                                    </div>
                                    :
                                    <div style={{ position: "fixed", marginLeft: -60 }}>
                                        <ShareIcons pic={item.wxShareImage} id={item.id} starType={"STAR_JOB"}
                                            title={item.wxShareTitle || `${util.fullEmployerName(item.employerName, item.department)}招聘${item.name}`}
                                            description={item.wxShareDescription || `年薪：${util.salaryText(item)}；${util.researchFields(item)} - 分享自领研网`} />
                                    </div>
                                }
                                {innerWidth < 1340 ? util.minWidth(24) : null}
                                <Item flex style={{ overflow: "hidden" }}>
                                    <Detail item={item} />

                                    <Box center justified style={{ fontSize: 16, lineHeight: 1, marginTop: 40 }}>
                                        推荐职位
                                        <a href="/searchall?tab=jobs&type=LATEST" className="text-primary" style={{ fontSize: 14 }}>
                                            查看更多
                                        </a>
                                    </Box>
                                    <Box>
                                        {this.job(0)}
                                        {util.minWidth(24)}
                                        {this.job(1)}
                                        {util.minWidth(24)}
                                        {this.job(2)}
                                    </Box>
                                    <Box>
                                        {this.job(3)}
                                        {util.minWidth(24)}
                                        {this.job(4)}
                                        {util.minWidth(24)}
                                        {this.job(5)}
                                    </Box>

                                    <Box center justified style={{ fontSize: 16, lineHeight: 1, marginTop: 40 }}>
                                        推荐机构
                                        <a href="/search" className="text-primary" style={{ fontSize: 14 }}>
                                            查看更多
                                        </a>
                                    </Box>
                                    <Box justified style={{ marginTop: 24, padding: 24, background: "#fff" }}>
                                        {this.state.employers.map(r =>
                                            <a key={r.id} className="text-center hover-title"
                                                style={{ width: 110, display: "block" }} target="_blank"
                                                href={`/searchall?tab=jobs&filters.employerId=${r.id}&query=${r.name}`}>
                                                <Box centerJustified>
                                                    {util.imageContain(r.logo, 80)}
                                                </Box>
                                                <div title={r.name}
                                                    style={{
                                                        fontSize: 14, lineHeight: "24px", color: "#333", marginTop: 20,
                                                        maxHeight: 68, overflow: "hidden",
                                                    }}>
                                                    {r.name}
                                                </div>
                                            </a>
                                        )}
                                    </Box>
                                </Item>
                            </Box>

                            {util.minWidth(24)}

                            <Item style={{ width: 326 }}>
                                <div style={{ background: "#fff", marginBottom: 24, padding: 24 }}>
                                    <Box centerJustified>
                                        {util.imageContain(`/api/employers/${employer.id}/logo`, 100)}
                                    </Box>
                                    <div className="text-center" style={{ marginTop: 14, fontSize: 18, lineHeight: "28px" }}>
                                        {employer.name}
                                    </div>
                                    <div className="text-minor" style={{ fontSize: 14, lineHeight: "24px" }}>
                                        {employer.teamIntro ?
                                            <Box start style={{ marginTop: 14, maxHeight: 118, overflow: "hidden" }}>
                                                简介
                                                {util.minWidth("1em")}
                                                <Item flex>{employer.teamIntro}</Item>
                                            </Box>
                                            : null
                                        }
                                        {employer.website ?
                                            <Box start style={{ marginTop: 14 }}>
                                                网址
                                                {util.minWidth("1em")}
                                                <Item flex>
                                                    <a href={employer.website} target="_blank"
                                                        style={{ color: "inherit", wordBreak: "break-all", textDecoration: "underline" }}>
                                                        {employer.website}
                                                    </a>
                                                </Item>
                                            </Box>
                                            : null
                                        }
                                        {employer.finance ?
                                            <Box start style={{ marginTop: 14 }}>
                                                融资
                                                {util.minWidth("1em")}
                                                <Item flex>{employer.finance}</Item>
                                            </Box>
                                            : null
                                        }
                                    </div>
                                    {this.state.siblingTotal > 0 ?
                                        <div style={{ marginTop: 20, borderTop: "1px solid #f2f2f2", paddingTop: 20, fontSize: 14 }}>
                                            <div style={{ lineHeight: "24px" }}>
                                                其他在招职位{this.state.siblingTotal}个：
                                                {util.unique(this.state.sibling.map(r => r.name)).slice(0, 2).map(n =>
                                                    <a key={n} title={n} className="text-primary hover-ul"
                                                        target="_blank" style={{ marginRight: "1em" }}
                                                        href={`/searchall?` + qs.stringify({
                                                            tab: "jobs",
                                                            query: employer.name + " " + n,
                                                            "filters.employerType": this.state.sibling[0].employerType,
                                                            "filters.name": n,
                                                        })}>
                                                        {n}
                                                    </a>
                                                )}
                                            </div>
                                            {this.state.sibling.slice(0, 2).map(r =>
                                                <a key={r.id} target="_blank" className="hover-title" href={"/jobs/" + r.id}
                                                    style={{ marginTop: 20, display: "block" }}>
                                                    <Box center>
                                                        <Item flex style={{ overflow: "hidden", fontSize: 16 }}>
                                                            <div title={r.name} className="ellipsis" style={{ color: "#333" }}>
                                                                {r.name}
                                                            </div>
                                                        </Item>
                                                        {util.minWidth("1em")}
                                                        <div className="text-primary">
                                                            {util.salaryText(r)}
                                                        </div>
                                                    </Box>
                                                    <div className="text-minor" style={{ lineHeight: "24px", marginTop: 10 }}>
                                                        {util.researchFields(r)}
                                                    </div>
                                                </a>
                                            )}
                                            {this.state.siblingTotal > 2 ?
                                                <Box centerJustified style={{ marginTop: 20 }}>
                                                    <a target="_blank"
                                                        href={`/searchall?` + qs.stringify({
                                                            tab: "jobs",
                                                            query: item.employerName,
                                                            "filters.employerName": item.employerName,
                                                        })}
                                                        className="bg-color-primary text-center" style={{
                                                            display: "block", color: "white", fontSize: 12,
                                                            width: 120, borderRadius: 2, lineHeight: "26px",
                                                        }}>
                                                        更多在招职位
                                                    </a>
                                                </Box>
                                                : null
                                            }
                                        </div>
                                        : null
                                    }
                                </div>

                                <div style={{ background: "#fff", marginBottom: 24, display: this.state.similar.length ? "block" : "none" }}>
                                    <div className="text-center text-primary" style={{ fontSize: 18, lineHeight: 1, padding: 24 }}>
                                        相似职位
                                    </div>
                                    <div style={{ padding: 14, border: "1px solid #f2f2f2" }}>
                                        {this.state.similar.map(r =>
                                            <a target="_blank" href={"/jobs/" + r.id} key={r.id}
                                                className="hover-bg-ea" style={{ display: "block", padding: 10 }}>
                                                <Box id={r.id} start style={{ color: "#333" }}>
                                                    {util.imageContain(`/api/employers/${r.employerId}/logo`, 48)}
                                                    {util.minWidth(16)}
                                                    <Item flex style={{ overflow: "hidden", lineHeight: "24px" }}>
                                                        <div className="ellipsis" style={{ fontSize: 16 }}>
                                                            {r.name}
                                                        </div>
                                                        <div className="ellipsis text-primary" style={{ fontSize: 14 }}>
                                                            {util.salaryText(r)} &middot; {r.city}
                                                        </div>
                                                        <div className="ellipsis" style={{ fontSize: 14 }}>
                                                            {util.fullEmployerName(r.employerName, r.department)}
                                                        </div>
                                                    </Item>
                                                </Box>
                                            </a>
                                        )}
                                        <Box centerJustified style={{ padding: "10px 0" }}>
                                            <a target="_blank" href={`/searchall?` +
                                                qs.stringify({
                                                    tab: "jobs",
                                                    "filters.employerType": item.employerType,
                                                    "filters.name": item.employerType === "COLLEGE" ? item.name : undefined,
                                                    "filters.subjects": item.employerType === "COLLEGE" ? item.subjects[0] : undefined,
                                                    "filters.industries": item.employerType === "COLLEGE" ? undefined : item.industries[0],
                                                })}
                                                className="bg-color-primary text-center" style={{
                                                    display: "block", color: "white", fontSize: 12,
                                                    width: 120, borderRadius: 2, lineHeight: "26px",
                                                }}>
                                                更多相似职位
                                            </a>
                                        </Box>
                                    </div>
                                </div>

                                <AdDetailRight />
                            </Item>
                        </Box>

                        {util.minHeight(40)}
                    </div>
                </div>

                <Partner />
                <Footer />
            </Box>
        )
    }
}

ReactDOM.render(<View />, document.body.firstChild as any)
